/* eslint-disable jsx-a11y/anchor-is-valid  -- to avoid refactoring of css and html structure */

import { FilesUploadInput } from "./FilesUploadInput";
import { useFilesUploader } from "./useFilesUploader";
import { type FilesUploader } from "../core";

interface ButtonProps {
  className?: string;
  title?: string;
  style?: React.CSSProperties;
}

interface FileUploaderInputProps {
  name: string;
  html?: { multiple: boolean; class: string };
}

export interface FilesUploadButtonProps {
  buttonProps: ButtonProps;
  inputProps: FileUploaderInputProps;
  uploader: InstanceType<typeof FilesUploader>;
}

export const FilesUploadButton = ({
  buttonProps,
  inputProps,
  uploader,
}: FilesUploadButtonProps) => {
  const { handleClick, handleInputChange, inputRef, allowedFileExtensions } =
    useFilesUploader({
      uploader,
    });

  const { title, className, style } = buttonProps;

  return (
    <>
      <FilesUploadInput
        {...inputProps}
        ref={inputRef}
        onChange={handleInputChange}
        accept={allowedFileExtensions}
      />

      <a href="#" className={className} onClick={handleClick} style={style}>
        <i className="fa-solid fa-plus" />
        &nbsp;
        {title}
      </a>
    </>
  );
};
